const promotionCounter = () => {
    var promotions = $(".product-offer");

    if (promotions.length > 0) {
        promotions.each((key, val) => {
            var promt = val;
            if (promt.childNodes.length > 3) {
                var proText = promt.childNodes[3];
                var countDownDate = new Date(proText.dataset.expireDate).getTime();
                var x = setInterval(function () {
                    var now = new Date().getTime();
                    var distance = countDownDate - now;
                    var hours = Math.floor(distance / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    proText.childNodes[1].innerHTML = hours + "h: " + minutes + "m: " + seconds + "s";

                    if (distance < 0) {
                        clearInterval(x);
                        promt.closest(promotions).classList.add('d-none');
                    }
                }, 1000);
            }
        });
    }
};

$(() => {
    promotionCounter();
});

module.exports = {
    promotionCounter,
};
